import React, { useContext } from 'react'
import ReactDOM from 'react-dom'

import isEmpty from 'lodash/isEmpty'
import { __DEV__ } from 'reacticoon/environment'
import clsx from 'clsx'
import MenuList from '@material-ui/core/MenuList'
import Button from '@material-ui/core/Button'
import IconButton from '@material-ui/core/IconButton'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import Divider from '@material-ui/core/Divider'
import CadFactionContext from 'components/CadFactionContext'
import SettingsContext from 'modules/settings/context'
import UserMeContext from 'components/UserMeContext'
import { getRoute } from 'reacticoon/routing'
import SecurityManager from 'modules/security/SecurityManager'
import { makeStyles } from '@material-ui/core/styles'
import LogoIcon from 'components/Logo'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import { Link } from 'reacticoon/routing'
import TypographyCustom from 'components/TypographyCustom'
import ChatIcon from '@material-ui/icons/Chat'
import DashboardIcon from '@material-ui/icons/Dashboard'
import HomeIcon from '@material-ui/icons/Home'
import PeopleIcon from '@material-ui/icons/People'
import SettingsIcon from '@material-ui/icons/Settings'
import CadIcon from 'components/PoliceBadge'
import BanlistIcon from '@material-ui/icons/Block'
import SIEMIcon from '@material-ui/icons/Announcement'
import MapIcon from '@material-ui/icons/Map'
import LogsIcon from 'components/LogsIcon'
import AccessTimeIcon from '@material-ui/icons/AccessTime'
import ConfirmationNumberIcon from '@material-ui/icons/ConfirmationNumber'
import BarChartIcon from '@material-ui/icons/BarChart'
import AttachMoneyIcon from '@material-ui/icons/AttachMoney'
import SecurityIcon from '@material-ui/icons/Security'
import DriveEtaIcon from '@material-ui/icons/DriveEta'
import DescriptionIcon from '@material-ui/icons/Description'
import FolderIcon from '@material-ui/icons/Folder'
import AssignmentIcon from '@material-ui/icons/Assignment'
import PersonIcon from '@material-ui/icons/Person'
import CodeIcon from '@material-ui/icons/Code'
import EmojiPeopleIcon from '@material-ui/icons/EmojiPeople'
import MoneyOffIcon from '@material-ui/icons/MoneyOff'
import BusinessIcon from '@material-ui/icons/Business'
import BuildIcon from '@material-ui/icons/Build'
import GavelIcon from '@material-ui/icons/Gavel'
import EventIcon from '@material-ui/icons/Event'
// Relatif : `pages/` n'est pas dans les alias webpack (contrairement à components/ et modules/)
import { hasBugtrackerAccess } from '../../pages/bugtracker/access'
// Icône avec badge de non-lus — monte aussi les notifications ciblées du bugtracker.
import { BugtrackerSidebarIcon } from '../../pages/bugtracker/notifications'
import createTabsConfigCad from 'components/createTabsConfigCad'
import { useCadUsefulData } from 'modules/cadUsefulData'
import getTabsConfigManagement from 'components/getTabsConfigManagement'
import getTabsConfigAdministration from 'components/getTabsConfigAdministration'

// Fonction pour obtenir l'icône par défaut selon la route
const getIconForRoute = (route, label) => {
  const iconMap = {
    // Gestion
    'SERVER_DASHBOARD': <DashboardIcon />,
    'SERVER_STATISTICS': <BarChartIcon />,
    'SERVER_REIMBURSEMENT': <AttachMoneyIcon />,
    'FACTION_COMPATIBILITY': <SecurityIcon />,
    'VEHICLES': <DriveEtaIcon />,
    'DARKCHAT': <ChatIcon />,
    'RANKING_MONEY': <AttachMoneyIcon />,
    
    // Administration
    'ADMIN_LIST': <PeopleIcon />,
    'ADMIN_LOGS_PANEL': <LogsIcon />,
    'ADMIN_SETTINGS': <SettingsIcon />,
    'LIVE_CONSOLE': <CodeIcon />,
    
    // CAD
    'CAD_DASHBOARD': <DashboardIcon />,
    'CAD_ARRESTS': <GavelIcon />,
    'CAD_WANTED': <PersonIcon />,
    'CAD_VEHICLES': <DriveEtaIcon />,
    'CAD_COMPANY_VEHICLES': <BusinessIcon />,
    'CAD_PETS': <EmojiPeopleIcon />,
    'CAD_BANS': <BanlistIcon />,
    'CAD_FINES': <MoneyOffIcon />,
    'CAD_PERMISSIONS': <SecurityIcon />,
    'CAD_BILLS': <DescriptionIcon />,
    'CAD_WORKFORCE': <PeopleIcon />,
    'CAD_PPA': <EventIcon />,
    'CAD_OPERATIONS': <SecurityIcon />,
    'CAD_OUT_OF_SERVICE': <BuildIcon />,
  }
  
  // Retourne l'icône si trouvée, sinon une icône par défaut
  return iconMap[route] || <FolderIcon />
}

const Item = ({
  route,
  currentRoute,
  subItem = false,
  subRoutesAsSubMenu = false,
  matchRoutes,
  tabs: tabsParam = [],
  children,
  classes,
  text,
  icon,
  onClose,
  isMobile,
  routes = [],
  forceShowAbove = false,
}) => {
  const tabs = tabsParam.filter(Boolean)
  const [isOpen, setIsOpen] = React.useState(false)
  const [isHovered, setIsHovered] = React.useState(false)
  const [menuPosition, setMenuPosition] = React.useState({ top: 0, left: 0 })
  const parentRef = React.useRef(null)
  const timeoutRef = React.useRef(null)

  // useEffect doit être appelé avant tout return conditionnel
  React.useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
    }
  }, [])

  const routeConfig = route ? getRoute(route) : null

  if (routeConfig && !SecurityManager.hasPermission(routeConfig.permissions)) {
    return null
  }

  const hasChildren = !isEmpty(tabs) || !!children

  // Calcule la position du submenu
  const updateMenuPosition = () => {
    if (parentRef.current && !isMobile) {
      const rect = parentRef.current.getBoundingClientRect()
      const submenuWidth = 240 // minWidth du submenu
      const estimatedHeight = tabs.length * 44 + 8 // Estimation hauteur du menu (44px par item + padding)
      
      // Position horizontale : à droite du parent par défaut
      let left = rect.right
      
      // Si le menu dépasse à droite, l'afficher à gauche
      if (left + submenuWidth > window.innerWidth) {
        left = rect.left - submenuWidth
      }
      
      // Position verticale : vérifier si assez de place en bas
      let position = { left }
      const spaceBelow = window.innerHeight - rect.top
      const spaceAbove = rect.bottom
      
      // Si pas assez de place en bas, étendre vers le haut
      if (estimatedHeight > spaceBelow && spaceAbove > spaceBelow) {
        // Ancrer en bas (bottom au lieu de top)
        position.bottom = window.innerHeight - rect.bottom
        position.top = 'auto'
      } else {
        // Ancrer en haut (comportement normal)
        position.top = rect.top
      }
      
      setMenuPosition(position)
    }
  }

  const handleMouseEnter = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }
    if (hasChildren && !isMobile) {
      updateMenuPosition()
      setIsHovered(true)
    }
  }

  const handleMouseLeave = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }
    timeoutRef.current = setTimeout(() => {
      setIsHovered(false)
    }, 100)
  }

  const isCurrentRoute = currentRoute?.name === route
    || (matchRoutes && currentRoute?.path?.match(matchRoutes))
    || tabs.some(tab => tab.route === currentRoute?.name)
    || routes.includes(currentRoute?.name)
    || tabs.some(tab => tab.route && currentRoute?.path?.startsWith(getRoute(tab.route)?.path))

  const item = <ListItem
    classes={{
      root: clsx(classes.menuItem, {
        [classes.currentRouteMain]: isCurrentRoute && !subItem,
        [classes.currentRouteSub]: isCurrentRoute && subItem,
        [classes.currentRouteParent]: isCurrentRoute && !subItem && hasChildren,
      }),
    }}
  >
    {icon && (
      <ListItemIcon classes={{ root: classes.menuItemIcon }}>
        {React.cloneElement(icon, { className: classes.menuItemIconSvg })}
      </ListItemIcon>
    )}
    <ListItemText primary={text} classes={{ primary: classes.menuItemText }} />
    {/* Indicateur visuel pour les items avec submenu */}
    {hasChildren && !isMobile && (
      <ListItemIcon style={{ minWidth: 24, marginLeft: 8 }}>
        <ChevronRightIcon style={{ fontSize: 18 }} />
      </ListItemIcon>
    )}
  </ListItem>

  const showSubmenu = !isMobile && hasChildren && isHovered

  return (
    <div
      ref={parentRef}
      className={clsx(classes.itemWrapper, {
        [classes.hasSubmenu]: hasChildren,
      })}
      onClick={() => isMobile && setIsOpen(!isOpen)}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {/* Afficher l'item - avec Link même s'il a un submenu */}
      {route ? (
        <Link 
          to={Link.getRoute(route)} 
          params={routeConfig?.defaultParams} 
          onClick={(e) => {
            // Déterminer si c'est la page courante
            const isCurrentPage = currentRoute === route || 
              (matchRoutes && typeof matchRoutes.test === 'function' && matchRoutes.test(window.location.pathname)) ||
              (routes && routes.length > 0 && routes.includes(currentRoute))
            
            // Fermer la sidebar seulement sur mobile ET si on change vraiment de page
            if (isMobile && !isCurrentPage) {
              onClose()
            }
            // Sur desktop, ne jamais fermer automatiquement la sidebar lors d'un clic sur un lien
            // Elle ne se fermera que via le bouton burger (géré dans handleDrawerClose)
          }}
        >
          {item}
        </Link>
      ) : item}
      
      {/* Submenu mobile */}
      {hasChildren && isMobile && (
        <div className={clsx(classes.subMenuMobile, { [classes.open]: isOpen })}>
          {children}
          {tabs.map(tab => (
            <Item 
              key={tab.route || tab.label}
              route={tab.route}
              currentRoute={currentRoute}
              classes={classes}
              text={tab.label}
              icon={tab.icon || getIconForRoute(tab.route, tab.label)}
              tabs={tab.tabs}
              subItem={true}
              subRoutesAsSubMenu={!!(tab.tabs && tab.tabs.length > 0)}
              onClose={onClose}
              isMobile={isMobile}
            />
          ))}
        </div>
      )}
      
      {/* Submenu desktop - position fixed calculée dynamiquement */}
      {/* Utilise un Portal pour rendre le submenu en dehors du DOM parent */}
      {showSubmenu && ReactDOM.createPortal(
        <div 
          className={classes.subMenuFixed}
          style={{
            top: menuPosition.top,
            bottom: menuPosition.bottom,
            left: menuPosition.left,
          }}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          {children}
          {tabs.map(tab => (
            <Item 
              key={tab.route || tab.label}
              route={tab.route}
              currentRoute={currentRoute}
              classes={classes}
              text={tab.label}
              icon={tab.icon || getIconForRoute(tab.route, tab.label)}
              tabs={tab.tabs}
              subItem={true}
              subRoutesAsSubMenu={!!(tab.tabs && tab.tabs.length > 0)}
              onClose={onClose}
              isMobile={isMobile}
            />
          ))}
        </div>,
        document.body
      )}
    </div>
  )
}

const useStyles = makeStyles((theme) => {
  return {
    // Wrapper pour chaque item (avec ou sans submenu)
    itemWrapper: {
      position: 'relative',
    },
    hasSubmenu: {
      // Items qui ont des submenus
    },
    
    // Submenu en position fixed (desktop) - utilisé pour TOUS les niveaux
    subMenuFixed: {
      position: 'fixed',
      paddingTop: 4,
      paddingBottom: 4,
      background: theme.isDark ? 'rgba(21, 73, 116, 0.6)' : 'rgba(255, 255, 255, 0.95)',
      backdropFilter: 'blur(10px)',
      boxShadow: theme.isDark ? '0 8px 32px rgba(0, 0, 0, 0.6), 0 0 0 1px rgba(33, 150, 243, 0.3)' : '0 8px 32px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(33, 150, 243, 0.2)',
      borderRadius: '0 8px 8px 0',
      overflowY: 'auto',
      zIndex: 99999,
      minHeight: 'fit-content',
      maxHeight: 'calc(100vh - 100px)',
      width: 'max-content',
      minWidth: 240,

      // Entrées compactées (44 → 37px) : le menu s'est allongé au fil des pages et
      // finissait par déborder de l'écran. Reste au-dessus de la cible tactile de 36px.
      '& .MuiListItem-root': {
        minHeight: 37,
        padding: '0 !important',
        display: 'block',
        width: '100%',
      },

      '& $menuItem': {
        paddingLeft: 20,
        paddingRight: 24,
        paddingTop: 7,
        paddingBottom: 7,
        margin: 0,
        fontSize: 14,
        minHeight: 37,
        background: 'transparent',
        border: 'none',
        borderLeft: '3px solid transparent',
        transition: 'all 0.2s ease',
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        width: 'auto',
      },

      '& $menuItem:hover': {
        background: theme.isDark ? 'rgba(33, 150, 243, 0.15)' : 'rgba(33, 150, 243, 0.08)',
        borderLeftColor: '#2196f3',
        paddingLeft: 20,
      },

      '& $currentRouteSub': {
        background: theme.isDark ? 'rgba(33, 150, 243, 0.2)' : 'rgba(33, 150, 243, 0.12)',
        borderLeftColor: '#2196f3',
        paddingLeft: 20,
      },

      '& $menuItemIcon': {
        minWidth: 36,
        color: theme.isDark ? 'rgba(255, 255, 255, 0.7)' : 'rgba(0, 0, 0, 0.6)',
        marginLeft: 16,
      },
      
      '& $menuItem:hover $menuItemIcon': {
        color: '#2196f3',
      },
      
      '& $menuItemIconSvg': {
        fontSize: 20,
      },

      '& $menuItemText': {
        fontSize: 14,
        fontWeight: 400,
        color: theme.isDark ? '#ffffff' : theme.palette.text.primary,
        whiteSpace: 'nowrap',
        flex: 1,
      },
      
      '& .MuiListItemText-primary': {
        fontSize: '14px !important',
        whiteSpace: 'nowrap !important',
        color: theme.isDark ? '#ffffff !important' : `${theme.palette.text.primary} !important`,
      },
      
      '& .MuiListItemText-root': {
        margin: '0 !important',
      },
    },
    
    // Submenu mobile
    subMenuMobile: {
      display: 'none',

      '& .MuiListItem-root': {
        paddingLeft: theme.spacing(10),
      },
    },
    open: {
      display: 'block'
    },
    toolbarIcon: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      padding: '0 8px',
      minHeight: 48,
      marginLeft: 'auto',
      flex: 1,
    },
    leftArea: {
      boxSizing: 'border-box',
      display: 'flex',
      alignItems: 'center',
      height: theme.app.header.height,
      position: 'relative',
      color: theme.isDark ? theme.palette.common.white : theme.palette.text.primary,
      background: theme.isDark ? 'linear-gradient(135deg, rgba(33, 150, 243, 0.1) 0%, rgba(33, 150, 243, 0.05) 100%)' : 'linear-gradient(135deg, rgba(33, 150, 243, 0.05) 0%, rgba(33, 150, 243, 0.02) 100%)',
      borderBottom: theme.isDark ? '1px solid rgba(255, 255, 255, 0.08)' : '1px solid rgba(0, 0, 0, 0.08)',
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      // En-tête du tiroir : 64px + 16px de marge intérieure pour un titre, c'est presque
      // deux entrées de menu. Doit rester cohérent avec le paddingTop de `menuList`.
      [theme.breakpoints.down('sm')]: {
        height: 48,
        paddingTop: 0,
        paddingBottom: 0,
      },
    },
    logoArea: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginLeft: theme.spacing(1),
      width: '100%',
      // Collé à gauche sur mobile : la marge est de la largeur perdue.
      // Déclaré APRÈS la propriété qu'il surcharge, pour que l'ordre de lecture
      // corresponde à l'ordre d'application.
      [theme.breakpoints.down('sm')]: {
        marginLeft: 0,
      },
    },
    logo: {
      marginLeft: theme.spacing(1),
      filter: 'drop-shadow(0 2px 4px rgba(33, 150, 243, 0.3))',
      transition: 'transform 0.3s ease',
      '&:hover': {
        transform: 'scale(1.05)',
      },
    },
    brand: {
      marginLeft: 12,
      color: theme.palette.common.white,
      fontWeight: 700,
      letterSpacing: '0.5px',
      textShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
    },
    drawerIcon: {
      color: theme.palette.common.white,
      transition: 'transform 0.3s ease',
    },
    drawerIconButton: {
      '&:hover $drawerIcon': {
        transform: 'rotate(180deg)',
      },
    },
    menuList: {
      // ⚠️ PAS de paddingTop de la hauteur d'en-tête : `leftArea` occupe déjà ses 64px
      // DANS LE FLUX, juste au-dessus. Le padding s'y ajoutait — d'où le vide sous le
      // logo, et 64px de contenu poussés hors de l'écran (donc une barre de défilement
      // dès qu'une entrée de menu était ajoutée).
      paddingTop: 0,
      height: `calc(100vh - ${theme.app.header.height})`,
      overflowX: 'visible',
      overflowY: 'auto',
      direction: 'rtl',

      ...theme.style.scrollbar,

      '& *': {
        direction: 'ltr',
      },

      // ⚠️ UN SEUL bloc pour ce point de rupture : il y en avait deux, et le second
      // écrasait entièrement le premier (même clé d'objet) — la hauteur mobile n'était
      // donc jamais appliquée. Le tiroir mobile a sa propre barre de titre, de 48px.
      [theme.breakpoints.down('sm')]: {
        paddingTop: 0,
        height: 'calc(100vh - 48px)',
      },
    },
    menuListSidebarClosed: {
      '& > div > a > .MuiListItem-root, & > div > .MuiListItem-root': {
        paddingLeft: 22,
      },

      '& > div > a > .MuiListItem-root .MuiListItemText-root, & > div > .MuiListItem-root .MuiListItemText-root': {
        opacity: 0,
        width: 0,
        overflow: 'hidden',
      },

      // Les textes dans les submenus restent visibles
      '& $subMenuFixed .MuiListItemText-root': {
        opacity: 1,
        width: 'auto',
        overflow: 'visible',
      },
    },
    menuItem: {
      color: 'rgba(255, 255, 255, 0.9)', // Changé pour être plus visible
      ...theme.style.focusPrimary,
      paddingLeft: 22,
      margin: '2px 8px',
      borderRadius: 8,
      // Compactage mobile : 44px par entrée sur un écran de 800px de haut, c'est moins de
      // 14 entrées visibles. On resserre hauteur, retrait et marges.
      [theme.breakpoints.down('sm')]: {
        paddingLeft: 12,
        paddingTop: 5,
        paddingBottom: 5,
        margin: '1px 6px',
        borderRadius: 6,
      },
      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
      position: 'relative',
      overflow: 'visible',

      '&::before': {
        content: '""',
        position: 'absolute',
        left: 0,
        top: 0,
        height: '100%',
        width: '3px',
        background: 'transparent',
        transition: 'background 0.3s ease',
      },

      '&:hover': {
        background: theme.isDark ? 'linear-gradient(135deg, rgba(33, 150, 243, 0.15) 0%, rgba(33, 150, 243, 0.08) 100%)' : 'linear-gradient(135deg, rgba(33, 150, 243, 0.08) 0%, rgba(33, 150, 243, 0.04) 100%)',
        paddingLeft: 26,
        color: theme.isDark ? theme.palette.common.white : theme.palette.text.primary,

        '&::before': {
          background: 'linear-gradient(180deg, #2196f3 0%, #1976d2 100%)',
        },
      },

      '& .MuiSvgIcon-root': {
        color: theme.isDark ? 'rgba(255, 255, 255, 0.85)' : 'rgba(0, 0, 0, 0.6)',
        fill: theme.isDark ? 'rgba(255, 255, 255, 0.85)' : 'rgba(0, 0, 0, 0.6)',
        transition: 'all 0.3s ease',
      },

      '&:hover .MuiSvgIcon-root': {
        color: '#2196f3',
        fill: '#2196f3',
        transform: 'scale(1.1)',
      },
    },
    menuItemText: {
      color: theme.isDark ? 'rgba(255, 255, 255, 0.9) !important' : `${theme.palette.text.primary} !important`,
      fontWeight: 500,
      '& .MuiTypography-root': {
        color: theme.isDark ? 'rgba(255, 255, 255, 0.9) !important' : `${theme.palette.text.primary} !important`,
      },
    },
    menuItemIcon: {
      minWidth: 40,
      // 40px reserves a une icone de 20px : on recupere la moitie sur mobile.
      [theme.breakpoints.down('sm')]: {
        minWidth: 30,
      },
    },
    menuItemIconSvg: {
      // Style appliqué via cloneElement
    },
    
    currentRouteMain: {
      background: theme.isDark ? 'linear-gradient(135deg, rgba(33, 150, 243, 0.25) 0%, rgba(33, 150, 243, 0.15) 100%)' : 'linear-gradient(135deg, rgba(33, 150, 243, 0.15) 0%, rgba(33, 150, 243, 0.08) 100%)',
      boxShadow: theme.isDark ? '0 2px 8px rgba(33, 150, 243, 0.2)' : '0 2px 8px rgba(33, 150, 243, 0.15)',
      paddingLeft: 26,

      '&::before': {
        content: '""',
        position: 'absolute',
        left: 0,
        top: 0,
        height: '100%',
        width: '4px',
        background: 'linear-gradient(180deg, #2196f3 0%, #1976d2 100%)',
        boxShadow: '0 0 8px rgba(33, 150, 243, 0.6)',
      },

      '& .MuiListItemIcon-root, & $menuItemText, & .MuiSvgIcon-root': {
        color: '#2196f3',
        fill: '#2196f3',
        fontWeight: 600,
      },
    },
    currentRouteSub: {
      background: theme.isDark ? 'linear-gradient(135deg, rgba(33, 150, 243, 0.15) 0%, rgba(33, 150, 243, 0.08) 100%)' : 'linear-gradient(135deg, rgba(33, 150, 243, 0.1) 0%, rgba(33, 150, 243, 0.05) 100%)',
      borderLeft: '3px solid #2196f3',
      marginLeft: theme.spacing(1),

      '& .MuiListItemIcon-root, & $menuItemText': {
        color: '#2196f3',
        fill: '#2196f3',
      },
    },
    currentRouteParent: {
      background: theme.isDark ? 'linear-gradient(135deg, rgba(33, 150, 243, 0.25) 0%, rgba(33, 150, 243, 0.15) 100%)' : 'linear-gradient(135deg, rgba(33, 150, 243, 0.15) 0%, rgba(33, 150, 243, 0.08) 100%)',
      boxShadow: theme.isDark ? '0 2px 8px rgba(33, 150, 243, 0.2)' : '0 2px 8px rgba(33, 150, 243, 0.15)',

      '&::before': {
        content: '""',
        position: 'absolute',
        left: 0,
        top: 0,
        height: '100%',
        width: '4px',
        background: 'linear-gradient(180deg, #2196f3 0%, #1976d2 100%)',
      },

      '& .MuiListItemIcon-root, & $menuItemText, & .MuiSvgIcon-root': {
        color: '#2196f3',
        fill: '#2196f3',
      },
    },
    
    bottomMenu: {
      '& .MuiListItem-root': {
        paddingLeft: theme.spacing(0.5)
      }
    },
    
    divider: {
      margin: '8px 16px',
      // 16px perdus par separateur, et ils sont maintenant quatre.
      [theme.breakpoints.down('sm')]: {
        margin: '6px 12px',
      },
      backgroundColor: theme.isDark ? 'rgba(255, 255, 255, 0.08)' : 'rgba(0, 0, 0, 0.08)',
      height: '1px',
    }
  }
})

const Sidebar = ({ route, isMobile, routeParams, tabsConfigParams, sidebarIsOpen, onClose }) => {
  const classes = useStyles()
	const { loggedInFaction } = useContext(CadFactionContext)
  const { userMe } = useContext(UserMeContext)
  const settings = useContext(SettingsContext)
  const cadUsefulData = useCadUsefulData()

  const tabsConfig = createTabsConfigCad(loggedInFaction, settings, userMe, cadUsefulData)

  if (!sidebarIsOpen && isMobile) {
    return null;
  }

  return (
    <React.Fragment>
      <div className={classes.leftArea}>
        <div className={classes.logoArea}>
          {!isMobile && (
            <Link to="DASHBOARD">
              <LogoIcon width={'auto'} height={42} fill="white" className={classes.logo} />
            </Link>
          )}
          <Link to="DASHBOARD">
            <TypographyCustom type="184" className={classes.brand} variant="headline">
              TASEv3
            </TypographyCustom>
          </Link>
          <div className={classes.toolbarIcon}>
            <IconButton onClick={onClose} className={classes.drawerIconButton}>
              <ChevronRightIcon className={classes.drawerIcon} />
            </IconButton>
          </div>
        </div>
      </div>

      <MenuList
        className={clsx(classes.menuList, { [classes.menuListSidebarClosed]: !sidebarIsOpen })}
      >
        <Item
          route="DASHBOARD"
          currentRoute={route}
          classes={classes}
          icon={<HomeIcon />}
          text="Accueil"
          onClose={onClose}
          isMobile={isMobile}
        />

        {SecurityManager.hasPermission("api.playerList") && (
          <Item
            route="RCON"
            currentRoute={route}
            classes={classes}
            icon={<PeopleIcon />}
            text="Joueurs"
            onClose={onClose}
            isMobile={isMobile}
          />
        )}

        {SecurityManager.hasPermission("api.playerList.canReply") && (
          <Item
            route="REPORTS"
            currentRoute={route}
            classes={classes}
            icon={<ChatIcon />}
            text="Reports"
            onClose={onClose}
            isMobile={isMobile}
          />
        )}

        {SecurityManager.hasPermission("api.ticket") && (
          <Item
            route="TICKET"
            currentRoute={route}
            classes={classes}
            icon={<ConfirmationNumberIcon />}
            text="Tickets"
            onClose={onClose}
            subRoutesAsSubMenu
            isMobile={isMobile}
            routes={[
              "TICKET",
              "TICKET_HISTORY",
              "TICKET_BLACKLIST",
              "PLAYER_TICKETS", // Tickets d'un joueur spécifique
            ]}
          >
            <Item
              route="TICKET"
              currentRoute={route}
              classes={classes}
              icon={<ConfirmationNumberIcon />}
              text="Tickets"
              onClose={onClose}
              isMobile={isMobile}
            />
            <Item
              route="TICKET_HISTORY"
              currentRoute={route}
              classes={classes}
              icon={<AccessTimeIcon />}
              text="Mes 20 derniers tickets"
              onClose={onClose}
              isMobile={isMobile}
            />
            <Item
              route="TICKET_BLACKLIST"
              currentRoute={route}
              classes={classes}
              icon={<BanlistIcon />}
              text="Blacklist"
              onClose={onClose}
              isMobile={isMobile}
            />
          </Item>
        )}

        {/* Séparateur - Section Gestion & Administration */}
        {(SecurityManager.hasPermission("api.gestion") || SecurityManager.hasPermission("api.administration")) && (
          <Divider className={classes.divider} />
        )}

        {SecurityManager.hasPermission("api.gestion") && (
          <Item
            text="Gestion"
            route="SERVER_DASHBOARD"
            currentRoute={route}
            classes={classes}
            icon={<DashboardIcon />}
            subRoutesAsSubMenu
            tabs={getTabsConfigManagement({ routeParams, tabsConfigParams }).tabs}
            routes={[
              "FACTION_COMPATIBILITY",
              "VEHICLES",
              "PLAYER", // Profil joueur
              "PLAYER_RECORD", // Casier judiciaire
              "PLAYER_SPY", // Espionnage
              "PLAYER_POSITION_HISTORY", // Historique de position
              "DARKCHAT", // DarkChat
              "RANKING_MONEY", // Tops
            ]}
            matchRoutes={/\/(ranking|darkchat)\.*/}
            onClose={onClose}
            isMobile={isMobile}
          />
        )}

        {SecurityManager.hasPermission("api.gestion") && (
          <Item
            route="FACTION"
            currentRoute={route}
            classes={classes}
            icon={<BusinessIcon />}
            text="Factions"
            onClose={onClose}
            isMobile={isMobile}
          />
        )}
      
        {SecurityManager.hasPermission("api.administration") && (
          <Item
            text="Administration"
            route="ADMIN_LIST"
            currentRoute={route}
            classes={classes}
            icon={<SettingsIcon />}
            subRoutesAsSubMenu
            tabs={getTabsConfigAdministration().tabs}
            routes={[
              "ADMIN_LIST",
              "LIVE_CONSOLE", // Console
            ]}
            onClose={onClose}
            isMobile={isMobile}
          />
        )}

        {/* Séparateur - Section Sécurité & Surveillance */}
        {(SecurityManager.hasPermission("api.logs") || SecurityManager.hasPermission("api.banlist") || SecurityManager.hasPermission("api.siem") || __DEV__) && (
          <Divider className={classes.divider} />
        )}

        {SecurityManager.hasPermission("api.logs") && (
          <Item
            route="LOGS"
            currentRoute={route}
            classes={classes}
            icon={<LogsIcon />}
            text="Logs"
            onClose={onClose}
            isMobile={isMobile}
          />
        )}

        {SecurityManager.hasPermission("api.banlist") && (
          <Item
            route="BANLIST"
            currentRoute={route}
            classes={classes}
            icon={<BanlistIcon />}
            text="Banlist"
            onClose={onClose}
            isMobile={isMobile}
          />
        )}

        {SecurityManager.hasPermission("api.siem") && (
          <Item
            route="SIEM"
            currentRoute={route}
            classes={classes}
            icon={<SIEMIcon />}
            text="SIEM"
            onClose={onClose}
          />
        )}

        {SecurityManager.hasPermission("api.mortRp.canSee") && (
          <Item
            route="MORT_RP_DOSSIERS"
            currentRoute={route}
            classes={classes}
            icon={<SIEMIcon />}
            text="Dossiers mort RP"
            onClose={onClose}
            isMobile={isMobile}
          />
        )}

        {__DEV__ && (
          <Item 
            route="MAP" 
            currentRoute={route} 
            classes={classes} 
            icon={<MapIcon />} 
            text="Map"     
            onClose={onClose}
            isMobile={isMobile}
          />
        )}
        
        {/* Séparateur - Section CAD */}
        {(SecurityManager.hasPermission("api.cad") || SecurityManager.hasPermission("cad")) && (
          <>
            <Divider className={classes.divider} />
            <Item
              route="CAD_DASHBOARD"
              currentRoute={route}
              classes={classes}
              icon={<CadIcon />}
              text="CAD"
              matchRoutes={/\/cad\.*/}
              subRoutesAsSubMenu
              tabs={tabsConfig().tabs}
              onClose={onClose}
              isMobile={isMobile}
              forceShowAbove={true}
            />
          </>
        )}

        {/*
          Séparateur - Section Suggestions & Bugs (sous le CAD)

          Section à part : le bugtracker ne relève ni de l'administration ni du CAD, et il
          s'adresse aux deux populations à la fois.

          ⚠️ Gate précis (et non les permissions larges de la route) : la permission CAD
          `bugtracker` est indexée par faction, hasBugtrackerAccess() balaie les factions
          de l'utilisateur — un membre CAD sans cette permission ne voit pas le bouton.
        */}
        {hasBugtrackerAccess() && (
          <>
            <Divider className={classes.divider} />
            <Item
              route="BUGTRACKER"
              currentRoute={route}
              classes={classes}
              icon={<BugtrackerSidebarIcon />}
              text="Suggestions & Bugs"
              onClose={onClose}
              isMobile={isMobile}
            />
          </>
        )}

      </MenuList>

      <MenuList className={classes.bottomMenu}>
        {isMobile && (
          <Button onClick={onClose} fullWidth>Fermer</Button>
        )}
      </MenuList>

      {/* Message de crédit */}
      <div style={{ 
        padding: '16px', 
        textAlign: 'center', 
        fontSize: '11px', 
        color: 'rgba(255, 255, 255, 0.4)',
        borderTop: '1px solid rgba(255, 255, 255, 0.05)',
      }}>
        Développé avec ❤️ par Max Monroe & Loïc Berry
      </div>
    </React.Fragment>
  )
}

export default Sidebar
